import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WhatsappLogo, X } from "@phosphor-icons/react";
import { CONTACT } from "../data/content";

const WHATSAPP_URL = "https://wa.me/+4401344578847";

const FloatingWhatsApp = () => {
  const [expanded, setExpanded] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!mounted) return null;

  return (
    <div data-testid="whatsapp-widget" className="fixed bottom-5 left-5 z-40 sm:bottom-6 sm:left-6">
      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="mb-3 w-72 border border-black/10 bg-white p-5 shadow-[0_24px_60px_rgba(10,19,38,0.18)]"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#25D366] text-white">
                  <WhatsappLogo size={20} weight="fill" />
                </span>
                <div>
                  <p className="editorial-h text-base text-brand-ink">Ben Kill</p>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-neutral-500">BTK Mortgages</p>
                </div>
              </div>
              <button
                data-testid="whatsapp-close-btn"
                onClick={() => setExpanded(false)}
                aria-label="Close"
                className="text-neutral-400 transition-colors duration-200 hover:text-brand-ink"
              >
                <X size={14} weight="bold" />
              </button>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-neutral-700">
              Hi 👋 Message us on WhatsApp — we usually reply within an hour during working hours.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-start-chat-btn"
              onClick={() => setExpanded(false)}
              className="mt-5 inline-flex items-center gap-2 bg-[#25D366] px-5 py-3 text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-white transition-[background-color,transform] duration-200 hover:bg-[#1ebe5a] hover:-translate-y-0.5"
            >
              <WhatsappLogo size={14} weight="fill" />
              Start chat
            </a>
            <p className="mt-5 text-[10px] leading-relaxed text-neutral-400">
              Or call {CONTACT.phone}. We never ask for passwords or card details by message.
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        data-testid="whatsapp-fab"
        aria-label="Chat on WhatsApp"
        onClick={() => setExpanded((v) => !v)}
        initial={{ opacity: 0, y: 24, scale: 0.8 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ scale: 1.06 }}
        whileTap={{ scale: 0.95 }}
        className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_14px_36px_rgba(37,211,102,0.5)]"
      >
        <span aria-hidden className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-40" />
        <WhatsappLogo size={26} weight="fill" className="relative" />
      </motion.button>
    </div>
  );
};

export default FloatingWhatsApp;
